module.exports = __webpack_public_path__ + "images/img_2_1-16d7c42378.png";